export const UserRegState = {
  /// <summary> Registration Process email confirm. </summary>
  AwaitingEmailConfirmation: 0,
  /// <summary> Send email to student to that effect. </summary>
  AwaitingBioCompletion: 1,
  /// <summary> User hasn't consented yet. </summary>
  AwaitingConsent: 2,
  /// <summary> Waiting for facility coordinator to approve. </summary>
  PendingApproval: 3,
  /// <summary> Returned for some reason. </summary>
  FixBio: 4,
  /// <summary> Complete rejected - user needs to be deleted. </summary>
  Rejected: 5,
  /// <summary> Registration complete and student is approved. </summary>
  Approved: 6,
  /// <summary> Student has been inactivated. </summary>
  Inactive: 7,
  /// <summary> Waiting for student to pay through PayPal. </summary>
  AwaitingSelfPay: 8,
  Archived: 9
};

export const CanPermissions = {
  "CanAssign": "CanAssign",
  "CanReport": "CanReport",
  "CanUpload": "CanUpload",
  "CanFERPA": "CanFERPA",
  "CanHIPAA": "CanHIPAA",
  "CanView": "CanView",
  "CanCoordinate": "CanCoordinate",
  "CanPlace": "CanPlace",
  "CanDownload": "CanDownload",
  "CanDelete": "CanDelete",
  "CanOrgDocs": "CanOrgDocs",
}

export const Categories = {
  CERTS: 1,
  LICENSES: 2,
  ELEARNING: 3,
  FORMS: 4,
  IMMUNIZATION: 5,
  INSURANCE: 6,
  SCREENS_CHECKS: 7,
  SITE_ORIENTATIONS: 8,
  CHECKR_BACKGROUND_CHECK: 9,
  CPNW_WATCH: 10,
  INDEPENDENT_BACKGROUND_CHECK: 11,
  INDEPENDENT_WATCH: 12,
};

export const ContactTypes = {
  FACULTY: 27,
  STUDENT: 36,
  EDUCATION: 58,
  CPNW: 42,
  HEALTHCARE: 87,
  CPNW_ADMIN: 90,
  CPNW_REVIEWER: 91
};

export const BackgroundCheckTypes = {
  Independent: 1,
  Checkr: 2
}

export const WatchCheckTypes = {
  Independent: 1,
  CPNW: 2
}

export const ContactCheckStatuses = {
  NotSubmitted: 1,
  Submitted: 2,
  RequirementCreated: 3,
  CheckrRequested: 4,
  Resent: 5,
}

export const ContactRequirementStatuses = {
  NotSubmitted: 1,
  Submitted: 2,
  Rejected: 3,
  Approved: 4,
  Expired: 5,
  InReview: 6,
  ConditionallyApproved: 7,
}

export const ImmuzationType = {
  Tdap: 5,
  TdapNew: 11
}

export const DATE_FORMAT_PATTERN = 'MM/dd/yyyy';

export const DeclinationEnum = {
  EggAllergy: "Egg Allergy",
  IngredientAllergy: "Ingredient Allergy",
  GuillainBarre: "Guillain Barre",
  Other: "Other",
  NonConverter: "Non-Converter",
  SeriesInProcess: "Series in Process",
  DeclinationForm: "Declination Form",
};